import { Interweave } from 'interweave';
import React, { PropsWithChildren } from 'react';

import styles from './Title.module.scss';

interface TitleProps extends PropsWithChildren {}

const Title: React.FC<TitleProps> = ({ children }) => {
  return (
    <Interweave
      className={styles.title}
      tagName="div"
      content={children?.toString()}
    />
  );
};

export default Title;
